import React from 'react';
import Typography from "@mui/material/Typography";
import PersonConsult from '../components/PersonConsult';
import TreinamentsPage from './TrainingsPage';

export default function ServicesPage(){
  return (
    <div>
      <span>
        <div className='reconect-banner'>
          <h5  className='reconect-text' style={{ color: "white" }}>SOLUÇÕES INTEGRADAS EM GESTÃO DE PESSOAS</h5>
        </div>
      </span>
      <Typography className="bullet reconect-infos">Onboarding (Integração)</Typography>
      <Typography className="bullet reconect-infos">Organograma</Typography>
      <Typography className="bullet reconect-infos">Manual do Colaborador</Typography>
      <Typography className="bullet reconect-infos">Descritivo de Cargos</Typography>
      <Typography className="bullet reconect-infos">Cargos e Salários</Typography>
      <Typography className="bullet reconect-infos">Certificação GPTW</Typography>
      <Typography className="bullet reconect-infos">Diagnóstico Organizacional (Pesquisa de Clima Organizacional, Setorial ou Individual)</Typography>
      <Typography className="bullet reconect-infos">Análise de Perfil Comportamental</Typography>
      <Typography className="bullet reconect-infos">Análise e medição do engajamento e motivação</Typography>
      <Typography className="bullet reconect-infos">Qualidade de Vida (Análise de benefícios que vão além de obrigatoriedade da convenção; incentivo à cultura; ações comemorativas e de conscientizações)</Typography>
      <Typography className="bullet reconect-infos">Gestão de Pessoas, integramos times e desenvolvemos talentos</Typography>
      <Typography className="bullet reconect-infos">Avaliação de Desempenho</Typography>
      <Typography className="bullet reconect-infos">Desligamento Humanizado</Typography>
      <br />
      <span>
        <div className='reconect-banner'>
          <h5  className='reconect-text' style={{ color: "white" }}>RECRUTAMENTO E SELEÇÃO</h5>
        </div>
      </span>
      <Typography className="bullet reconect-infos">Atração de Talentos: encontramos os profissionais ideais para sua empresa</Typography>
      <Typography className="bullet reconect-infos">Triagem Eficiente e Personalizada: com análise de competências</Typography>
      <Typography className="bullet reconect-infos">Fit Cultural: alinhamento estratégico de valores da empresa e do candidato</Typography>
      <Typography className="bullet reconect-infos">Agilidade no Processo: contratações rápidas e assertivas</Typography>
      <Typography className="bullet reconect-infos">Impulsionar Resultados: profissionais qualificados e equipes mais produtivas</Typography>
      <br />
      <TreinamentsPage />
      <br />
      <PersonConsult />
      <br />
      <br />
    </div>
  );
}
